import { createI18n } from 'vue-i18n'

const i18n = createI18n({
  locale: 'en', // set default locale
  fallbackLocale: 'de', // set fallback locale
  messages: {},
  silentFallbackWarn: true,
})

export default i18n